(function () {'use strict';}());
angular.module("elidb").directive('refineView', function($document,$timeout,ELIService) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/refine.html?v=3',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.showRefineHint = false;
        $scope.showFamilyPopover = false;

        $scope.$watch("tech",function(val){
          if(!$scope.tech || !$scope.tech.txtSurveyTooltip) return;
          $scope.hintcontent = {selector:"button.refine-hint",label:"header",tooltip:$scope.tech.txtSurveyTooltip.value};
        });

        $scope.onKeyDown = function($event) {
          var target = $event.currentTarget;
          if($event.keyCode !== 13 && $event.keyCode !== 32) return;
          $event.preventDefault();
          $timeout(function(){
              angular.element(target).trigger("click");
          },0);
        };

        $scope.toggleRefineHint = function(){
          
          $scope.showRefineHint = !$scope.showRefineHint;
        };

        $scope.toggleFamilyPopover = function() {
          $scope.showFamilyPopover = !$scope.showFamilyPopover;
        };

        $scope.tagIsDisabled = function(tag) {
            if(tag.disabled) return true;
            return false;
            /*
            var dependencies = ELIService.tagDependencies[tag.id];
            if(!dependencies) return false;

            var disabled = false;

            for(var j = 0, numDeps = dependencies.length; j < numDeps; j++) {
              var dependency = dependencies[j];
              var target = ELIService.tagDictionary[dependency.dependsOn];
              if(!target) continue;

              var satisfied = target[dependency.dependsProperty] == dependency.dependsValue;
              if(!satisfied) continue;

              disabled = dependency.setValue;
            }

            return disabled; */
        };

        $scope.share = function() {
          $scope.createUserSpecificLink();
        };

        $scope.showSelectedTags = true;

        $scope.toggleSelectedTags = function($event) {
          $event.preventDefault();
          $event.stopImmediatePropagation();

          $scope.showSelectedTags = !$scope.showSelectedTags;
        };

        $scope.showServices = true;
        
        $scope.toggleShowServices = function($event) {
          $event.preventDefault();
          $event.stopImmediatePropagation();

          $scope.showServices= !$scope.showServices;
        };

        $document.on("keyup",onKeyUp);

        function onKeyUp(e){
        	if(e.keyCode === 76 && e.ctrlKey === true){
        		$scope.createLocationSpecificLink();
        	}
          if(e.keyCode === 85 && e.ctrlKey === true){
            $scope.createUserSpecificLink();
          }
        }
      }  
    };
  });